<template>
  <div class="json-container">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
      name: 'Json'
  }
</script>
